import React, { useEffect } from 'react'
import { AvailyEvent } from '@customTypes/Availy'
import { useSetInitialState } from '@hooks/useSetInitialState'
import { useSetClinicLogoUrl } from '@hooks/useSetClinicLogoUrl'
import { postParentMsg } from 'src/utils/postMessage'
import { useSetOriginalClinicId } from '@hooks/useSetOriginalClinicId'
import { AppMode } from '@customTypes/Generic'

interface Props {
  children: React.ReactNode | null
  asModal: boolean
  appMode: AppMode
  isVisible: boolean
}

export const InitialStateWrapper = ({ children, asModal, appMode, isVisible }: Props) => {
  useSetInitialState(asModal, appMode)
  useSetOriginalClinicId(isVisible)
  useSetClinicLogoUrl()

  useEffect(() => {
    postParentMsg({ type: AvailyEvent.READY })
  }, [])

  return <>{children}</>
}
